(function ($) {
  $.fn.selectpicker.defaults = {
    noneSelectedText: '選択されていません',
    noneResultsText: '\'{0}\'は見つかりません',
    countSelectedText: '{0}/{1} 選択中',
    maxOptionsText: ['選択上限数を超えています(最大{n}{var})', 'グループの選択上限数を超えています(最大{n}{var})', ['アイテム', 'アイテム']],
    selectAllText: '全て選択',
    deselectAllText: '選択をクリア',
    multipleSeparator: ', '
  };
})(jQuery);
